import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";



import exteriorbuild from "../images/Exterior p.jpg";
import exteriorphoto from "../images/Exterior new build.jpg";
import exterior from "../images/Exterior new photo.jpg";
import exteriorimg from "../images/Exterior a2z services.jpg";

import civilwork from "../images/Cibil.jpg";
import civildesign from "../images/Civil house.jpg";
import Civilhouse from "../images/Civil Design.jpg";
import exteriorimg2 from "../images/Exterior.jpg"

import Exteriorhouse from "../images/Exterior house.jpg";
import civildesign6  from "../images/Civil Work & Exterior.jpg";
import Civilhouse2 from "../images/Civil Work new.jpg";
import civil6 from "../images/Civil 6.jpg"


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'




import Header from "../inc/Header";

function Exterior() {
      const phoneNumber = "919732000307"; // Replace with your number (with country code, no +)
  const message = "Hello..";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${919732000307}?text=${encodedMessage}`;
  return (
    <div>

      <Header />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" color="maroon" />
      <div className='exteriordesign'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Civil Work and Exterior</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "5px" }} className="fixed-bottom  mb-1">
        <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
          <button className='whatsAppicon highlight-btn2'>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
            </svg>
          </button>
        </a>
      </div>
      <div className='az2service'>
        <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>

                          <img src={exteriorbuild} className="card-img-top" alt="exteriorbuild"/>

                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Exterior </h5>
                         

                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2' style={{color:"white"}} href='tel: 9732000307'> Book Now</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={exteriorphoto} className="card-img-top" alt="exteriorphoto"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Exterior</h5>
                        
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={exterior} className="card-img-top" alt="exterior"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2">Exterior </h5>
               
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={exteriorimg} className="card-img-top" alt="exteriorimg"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2" >Exterior                                 </h5>
                      
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

       <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>

                          <img src={civilwork} className="card-img-top" alt="civilwork"/>

                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Exterior </h5>
                         

                          <div className="d-flex justify-content-between align-items-center mb-0">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={civildesign} className="card-img-top" alt="civildesign"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Exterior</h5>
                        
                          <div className="d-flex justify-content-between align-items-center mb-0">

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={Civilhouse} className="card-img-top" alt="Civilhouse"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2">Exterior </h5>
               
                          <div className="d-flex justify-content-between align-items-center mb-0">

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={exteriorimg2} className="card-img-top" alt="exteriorimg"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2" >Exterior                                 </h5>
                      
                          <div className="d-flex justify-content-between align-items-center mb-0">

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>

                          <img src={Exteriorhouse} className="card-img-top" alt="Exteriorhouse"/>

                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Exterior </h5>
                         

                          <div className="d-flex justify-content-between align-items-center mb-0">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={civildesign6} className="card-img-top" alt="civildesign"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Exterior</h5>
                        
                          <div className="d-flex justify-content-between align-items-center mb-0">

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={Civilhouse2} className="card-img-top" alt="Civilhouse"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2">Exterior </h5>
               
                          <div className="d-flex justify-content-between align-items-center mb-0">

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={civil6} className="card-img-top" alt="exteriorimg"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2" >Exterior                                 </h5>
                      
                          <div className="d-flex justify-content-between align-items-center mb-0">

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

  <br />

      <br />


      </div>
    
    </div>
  )
}

export default Exterior